var map = {
	"./img1.webp": 1620,
	"./img1@2x.webp": 1586,
	"./img2.webp": 8961,
	"./img2@2x.webp": 3297,
	"./img3.webp": 4230,
	"./img3@2x.webp": 300,
	"./img4.webp": 6235,
	"./img4@2x.webp": 603,
	"./img5.webp": 3416,
	"./img5@2x.webp": 8494
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1937;